<template>
  <pre class="DiffCell" :class="[theme, type]">{{ value }}</pre>
</template>

<script>
export default {
  props: {
    theme: { type: String, required: true },
    type: { type: String, required: true },
    value: { type: null },
  },
}
</script>

<style lang="scss">
.DiffCell {
  &.danger {
    background: $danger-light;
    color: $danger-dark;
  }

  &.info {
    background: $info-lighter;
    color: $info-dark;
  }

  &.success {
    background: $success-light;
    color: $success-dark;
  }

  &.char {
    white-space: break-spaces;
  }

  &.word {
    margin-right: $uh;
  }
}
</style>
